import './App.less';
import Footer from './Model/Footer';
import Header from './Model/Header';
import logo from './logo.jpeg'
import { useNavigate } from 'react-router-dom';

function ComingSoon() {
  
  const navigate = useNavigate();
      const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems : [
    { 
      type: 'link', 
      name: 'Home', 
      link: '/',
      onClick: () => {
        
      navigate("/")
      }
    },
    { 
      type: 'link', 
      name: 'About', 
      link: '#about',
      onClick: () => {
         navigate("/aboutus")
      }
    },
    { 
      type: 'link', 
      name: 'Service', 
      link: '#why',
      
      onClick: () => {
         navigate("/service")
      }
    },
    { 
      type: 'link', 
      name: 'Gallery', 
      link: '/gallery',  // navigate to a separate route
       onClick: () => {
         navigate("/gallery")
      }
    },
    { 
      type: 'link', 
      name: 'Contact', 
      link: '#contact',
      onClick: () => {
         navigate("/contact")
      }
    }
  ]
  };

  const Brand = "Aspire Homes"
  return (
    <>
      <Header {...headerConfig} />

      <div className="coming-soon-container">
        <h1>Coming Soon</h1>
        <p>Our website is under construction. Stay tuned!</p>
        <button onClick={() => navigate('/')}>Go Back Home</button>
      </div>

      <Footer />
    </>
  );
}

export default ComingSoon;
